<template>
  <div class="copy-content">
    <div class="copy-url">{{address}}</div>
    <div :class="['copy-btn', hasCopy&&'has-copy']" @click="copyAddress">{{hasCopy?'已复制':'复制链接'}}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data () {
    return {
      address: '',
      hasCopy: false,
    }
  },
  computed: {
    ...mapGetters([
      'WorksProjectId',
    ])
  },
  created () {
    this.address = `${window.location.origin}/draftpreview/index.html?id=${window.draftId || this.WorksProjectId}`
  },
  methods: {
    copyAddress () {
      if (this.hasCopy) return;
      this.hasCopy = true;
      setTimeout(() => {
        this.hasCopy = false;
      }, 2000);
      let ok = this.copyToClipboard(this.address);
      if (!ok) {
        console.error('copy failed')
      }
    },
    copyToClipboard(text) {
      let suc = false
      try {
        navigator.clipboard.writeText(text);
      } catch (err) {
        suc = false
      }
      return suc;
    }
  }
}
</script>

<style lang="scss" scoped>
.copy-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 530px;
    height: 40px;
    border-radius: 4px;
    border: 1px solid #E4E4E4;
    margin-right: 20px;
  }
  .copy-url {
    display: flex;
    align-items: center;
    width: 420px;
    height: 40px;
    padding: 0 10px;
    white-space: nowrap;
    overflow-x: scroll;
    overflow-y: hidden;
    user-select: text !important;
    color: #aaa9a9;

    &::-webkit-scrollbar {
      display: none;
    }
  }
  .copy-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 40px;
    font-size: 14px;
    color: #fff;
    font-weight: 400;
    background-color: #5778fb;
    border-radius: 4px;
    cursor: pointer;
    &:hover {
      background-color: #7d95f5;
    }
  }
  .has-copy {
    background-color: #5ACD4B;
  }
</style>



// WEBPACK FOOTER //
// src/components/topnav/exportDialog/dialogSharePart.vue